
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  name: "ExscientiaBanner"
})
export default class ExscientiaBanner extends Vue {
}
